import { CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const TopCountriesTableFallback = () => (
  <>
    <CardHeader className="pb-0 gap-0">
      <CardTitle className="flex w-full justify-between items-center">
        <Skeleton className="h-7 w-1/3" />
      </CardTitle>
    </CardHeader>
    <CardContent className="px-6">
      <div className="grid grid-cols-2 gap-6">
        <Skeleton className="h-[455px]" />
        <div className="flex flex-col justify-between h-full pb-2">
          <div className="space-y-2">
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-[87%]" />
            <Skeleton className="h-8 w-[80%]" />
            <Skeleton className="h-8 w-[55%]" />
            <Skeleton className="h-8 w-[50%]" />
            <Skeleton className="h-8 w-[50%]" />
            <Skeleton className="h-8 w-[40%]" />
            <Skeleton className="h-8 w-[20%]" />
            <Skeleton className="h-8 w-[10%]" />
            <Skeleton className="h-8 w-[5%]" />
          </div>
          <div className="flex justify-end">
            <div className="flex items-center space-x-2">
              <Skeleton className="size-8 rounded-md" />
              <Skeleton className="size-8 rounded-md" />
              <Skeleton className="size-8 rounded-md" />
              <Skeleton className="size-8 rounded-md" />
            </div>
          </div>
        </div>
      </div>
    </CardContent>
  </>
)
